<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center justify-between gap-3 mb-6">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">account_balance_wallet</mat-icon>
      <h1 class="text-xl md:text-2xl font-bold text-gray-800">Administrador de Wallets</h1>
    </div>
    <button type="button" (click)="openModal()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
      <span class="hidden sm:inline">Crear Wallet</span>
      <span class="sm:hidden">+</span>
    </button>
  </div>

  <!-- Indicador de Carga -->
  <div *ngIf="loading" class="flex justify-center items-center p-4">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Card Tabla Wallets -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="!loading">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
        Listado de Wallets
      </h2>
    </div>

    <!-- Tabla Desktop: hidden lg:block -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" class="w-full">
        <ng-container matColumnDef="operator">
          <th mat-header-cell *matHeaderCellDef>Operador</th>
          <td mat-cell *matCellDef="let wallet"><span class="text-xs">{{ wallet.operator }}</span></td>
        </ng-container>

        <ng-container matColumnDef="crypto">
          <th mat-header-cell *matHeaderCellDef>Crypto</th>
          <td mat-cell *matCellDef="let wallet"><span class="text-xs">{{ wallet.crypto }}</span></td>
        </ng-container>

        <ng-container matColumnDef="network">
          <th mat-header-cell *matHeaderCellDef>Red</th>
          <td mat-cell *matCellDef="let wallet"><span class="text-xs">{{ wallet.network }}</span></td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>Direcci&oacute;n</th>
          <td mat-cell *matCellDef="let wallet"><span class="text-xs break-all">{{ wallet.address }}</span></td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let wallet">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="wallet.isActive ? '#dcfce7' : '#f3f4f6'"
              [style.color]="wallet.isActive ? '#166534' : '#6b7280'">
              {{ wallet.isActive ? 'ACTIVA' : 'INACTIVA' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="width: 120px; text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let wallet" style="width: 120px; text-align: center;">
            <div class="flex items-center justify-center gap-1">
              <button title="Editar wallet" (click)="openEditModal(wallet)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #93c5fd; border-radius: 6px; background: #eff6ff; cursor: pointer;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
              </button>
              <button [title]="wallet.isActive ? 'Desactivar wallet' : 'Activar wallet'" (click)="toggleWalletStatus(wallet)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border-radius: 6px; cursor: pointer;"
                [style.border]="wallet.isActive ? '1px solid #fecaca' : '1px solid #bbf7d0'"
                [style.background]="wallet.isActive ? '#fef2f2' : '#f0fdf4'"
                onmouseover="this.style.opacity='0.8'" onmouseout="this.style.opacity='1'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px;"
                  [style.color]="wallet.isActive ? '#dc2626' : '#16a34a'">
                  {{ wallet.isActive ? 'power_settings_new' : 'play_circle' }}
                </mat-icon>
              </button>
              <button title="Eliminar wallet" (click)="confirmAndDeleteWallet(wallet)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;"
                onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['operator','crypto','network','address','status','actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['operator','crypto','network','address','status','actions']"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center text-gray-400 py-8" colspan="6">
            No hay wallets registradas
          </td>
        </tr>
      </table>
    </div>

    <!-- Cards Mobile: lg:hidden -->
    <div class="lg:hidden space-y-3 p-4">
      <div *ngFor="let wallet of dataSource.filteredData; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full shrink-0"
              [style.background]="wallet.isActive ? '#dcfce7' : '#f3f4f6'"
              [style.color]="wallet.isActive ? '#166534' : '#6b7280'">
              {{ wallet.isActive ? 'ACTIVA' : 'INACTIVA' }}
            </span>
            <span class="text-xs font-semibold text-gray-700 truncate">{{ wallet.operator }} - {{ wallet.crypto }}</span>
          </div>
          <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
            [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Operador</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ wallet.operator }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Crypto</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ wallet.crypto }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Red</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ wallet.network }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Estado</span>
              <p class="font-medium mt-0.5" [style.color]="wallet.isActive ? '#166534' : '#6b7280'">
                {{ wallet.isActive ? 'Activa' : 'Inactiva' }}
              </p>
            </div>
            <div class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Direcci&oacute;n</span>
              <p class="text-gray-700 font-mono font-medium mt-0.5 break-all text-xs">{{ wallet.address }}</p>
            </div>
          </div>
          <div class="flex gap-2 mt-3 pt-3 border-t border-gray-100">
            <button title="Editar" (click)="openEditModal(wallet)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #93c5fd; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">edit</mat-icon>
              Editar
            </button>
            <button [title]="wallet.isActive ? 'Desactivar' : 'Activar'" (click)="toggleWalletStatus(wallet)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; cursor: pointer; font-size: 0.75rem; font-weight: 600;"
              [style.border]="wallet.isActive ? '1px solid #fecaca' : '1px solid #bbf7d0'"
              [style.background]="wallet.isActive ? '#fef2f2' : '#f0fdf4'"
              [style.color]="wallet.isActive ? '#dc2626' : '#16a34a'">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px;"
                [style.color]="wallet.isActive ? '#dc2626' : '#16a34a'">
                {{ wallet.isActive ? 'power_settings_new' : 'play_circle' }}
              </mat-icon>
              {{ wallet.isActive ? 'Desactivar' : 'Activar' }}
            </button>
            <button title="Eliminar" (click)="confirmAndDeleteWallet(wallet)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">delete</mat-icon>
              Eliminar
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="dataSource.filteredData.length === 0" class="text-center text-gray-400 py-8">
        No hay wallets registradas
      </div>
    </div>

    <!-- Paginaci&oacute;n -->
    <div class="p-4">
      <mat-paginator
        [length]="dataSource.data.length"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>

<!-- Modal para Crear/Editar Wallet -->
<div *ngIf="isModalOpen"
  class="fixed inset-0 z-50 flex justify-center items-center"
  style="background: rgba(0,0,0,0.5);"
  (click)="closeModal()">
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header gradiente verde -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">{{ isEditing ? 'edit' : 'add_circle' }}</mat-icon>
        {{ isEditing ? 'Editar' : 'Crear Nueva' }} Wallet
      </h2>
    </div>

    <div class="p-5">
      <form [formGroup]="walletForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Operador</mat-label>
          <mat-select formControlName="operator">
            <mat-option *ngFor="let op of operators" [value]="op">{{ op }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Crypto</mat-label>
          <mat-select formControlName="crypto">
            <mat-option *ngFor="let c of cryptos" [value]="c">{{ c }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Red (Network)</mat-label>
          <mat-select formControlName="network">
            <mat-option *ngFor="let net of networks" [value]="net">{{ net }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Direcci&oacute;n de Wallet</mat-label>
          <input matInput formControlName="address" (paste)="handlePaste($event)" placeholder="Pega aqu&iacute; la direcci&oacute;n" />
          <mat-error *ngIf="walletForm.get('address')?.hasError('required')">La direcci&oacute;n es requerida</mat-error>
          <mat-error *ngIf="walletForm.get('address')?.hasError('minlength')">La direcci&oacute;n es demasiado corta</mat-error>
        </mat-form-field>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-2">
          <button type="submit" [disabled]="walletForm.invalid || loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="walletForm.invalid || loading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon *ngIf="!loading" style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
            <mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
            {{ loading ? 'Guardando...' : 'Guardar' }}
          </button>
          <button type="button" (click)="closeModal()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
